/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api
 */

import { message } from 'ant-design-vue'
import { ref } from 'vue'
import { v1_bbs_getNews_get } from 'server/modules/4333'
// 获取BBS最新的
export const v1_bbs_getNews_get_ = function(params) {
  const bbsList = ref([])
  const getNews = async () => {
    const { success, data, retInfo } = await v1_bbs_getNews_get({})
    if (success) {
      bbsList.value = data.slice(0, 5)
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  getNews()
  return {
    bbsList
  }
}
